import { render, staticRenderFns } from "./historyDispatch.vue?vue&type=template&id=395b4706&scoped=true&"
import script from "./historyDispatch.vue?vue&type=script&lang=js&"
export * from "./historyDispatch.vue?vue&type=script&lang=js&"
import style0 from "./historyDispatch.vue?vue&type=style&index=0&id=395b4706&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b4706",
  null
  
)

export default component.exports